import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { SectionConfigModel } from '../../models/section-configuration.model';


@Component({
    selector: 'topbar-filters-configuration',
    templateUrl: 'topbar-filters-configuration.component.html',
    styleUrls: ['topbar-filters-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopbarFiltersConfigurationComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() sectionConfig: SectionConfigModel;

  expanded: boolean = false;

  form: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.form = this.fb.group({
      show: this.fb.control(this.sectionConfig.topbarFiltersConfig?.show),
      showChips: this.fb.control(this.sectionConfig.topbarFiltersConfig?.showChips),
    });

    this.parentFormGroup.addControl('topbarFiltersConfig', this.form);
  }
}
